import { Group, Image, useMantineColorScheme, Avatar } from '@mantine/core';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { Contact, getContact } from '@/utils/dawa_api/contact';
import { getCurrentCustomerId, getStoredUserData } from '@/utils/token';

export function Header() {
  const { colorScheme } = useMantineColorScheme();
  const [contact, setContact] = useState<Contact | null>(null);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const customerId = getCurrentCustomerId();
        const userData = getStoredUserData();
        
        if (customerId && userData?.id) {
          const contactData = await getContact(parseInt(customerId), parseInt(userData.id));
          if (contactData) {
            setContact(contactData);
          }
        }
      } catch (error) {
        console.error("Error fetching contact:", error);
      }
    };

    fetchContact();
  }, []);

  return (
    <Group 
      justify="space-between" 
      style={{ 
        height: '100%', 
        margin: '0 20px',
        display: 'flex'
      }}
    >
      {colorScheme === 'dark' ? (
        <Image
          src="/full_logo_dark_mode.svg"
          alt="Full Logo"
          height={40}
          fit="contain"
          style={{ maxWidth: '150px'}}
        />
      ) : (
        <Image
          src="/full_logo.svg"
          alt="Full Logo"
          height={40}
          fit="contain"
          style={{ maxWidth: '150px'}}
        />
      )}
      <Link href="/profile" style={{ textDecoration: 'none' }}>
        <Avatar
          radius={9999}
          size={40}
          color="blue"
          styles={{
            root: {
              cursor: 'pointer'
            }
          }}
        >
          {contact && contact.firstName && contact.lastName ? (
            `${(contact.firstName[0] || '').toUpperCase()}${(contact.lastName[0] || '').toUpperCase()}`
          ) : 'FT'}
        </Avatar>
      </Link>
    </Group>
  );
}
